export const CONTACT = {
  phoneDisplay: "0543 412 12 46",
  phoneRaw: "905434121246",
  email: "ecndijital@gmail.com",
  instagram: "@ecndijital",
  instagramUrl: "https://instagram.com/ecndijital",
  whatsapp: "https://wa.me/905434121246",
};

export const whatsappLink = (msg) =>
  `${CONTACT.whatsapp}?text=${encodeURIComponent(
    msg || "Merhaba ECN Dijital, dijital pazarlama hizmetleriniz hakkında bilgi almak istiyorum."
  )}`;

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const SERVICES = [
  {
    id: "sosyal-medya-yonetimi",
    number: "01",
    title: "Sosyal Medya Yönetimi",
    desc: "Instagram, TikTok ve LinkedIn'de markanıza özel içerik takvimi, topluluk yönetimi ve düzenli büyüme analizi.",
    chips: ["İçerik Takvimi", "Topluluk Yönetimi", "Aylık Raporlama"],
    icon: "Share2",
  },
  {
    id: "meta-reklamlari",
    number: "02",
    title: "Meta Reklamları",
    desc: "Instagram ve Facebook'ta A/B testli, yüksek dönüşüm odaklı reklam kampanyaları ve remarketing kurguları.",
    chips: ["Hedef Kitle Kurulumu", "A/B Test", "ROAS Takibi"],
    icon: "Target",
  },
  {
    id: "google-ads",
    number: "03",
    title: "Google Ads",
    desc: "Arama ağı ve Performance Max kampanyalarıyla satın alma niyetindeki müşterileri tam zamanında yakalayın.",
    chips: ["Anahtar Kelime Stratejisi", "Bütçe Optimizasyonu", "Dönüşüm Takibi"],
    icon: "Search",
  },
  {
    id: "icerik-yonetimi",
    number: "04",
    title: "İçerik Yönetimi",
    desc: "Reels ve kısa video senaryoları, grafik tasarım ve markanızın diline uygun reklam metinleri.",
    chips: ["Video Kurgu", "Grafik Tasarım", "Metin Yazarlığı"],
    icon: "PenTool",
  },
  {
    id: "strateji-ve-raporlama",
    number: "05",
    title: "Strateji ve Raporlama",
    desc: "Rakip analizi, büyüme yol haritası ve her ay ölçülebilir sonuçlarla şeffaf raporlama.",
    chips: ["Rakip Analizi", "Yol Haritası", "Aylık Rapor"],
    icon: "BarChart3",
  },
];

export const WHY_US = [
  {
    icon: "BarChart3",
    title: "Veri Odaklı Yaklaşım",
    desc: "Her karar tahmine değil veriye dayanır; kampanyalarınız sürekli ölçülür ve optimize edilir.",
  },
  {
    icon: "FileText",
    title: "Şeffaf Raporlama",
    desc: "Her ay ne yapıldığını ve hangi sonuçların alındığını anlaşılır raporlarla görürsünüz.",
  },
  {
    icon: "Layers",
    title: "360° Hizmet",
    desc: "Sosyal medyadan reklama, içerikten stratejiye tüm dijital ihtiyaçlarınız tek çatı altında.",
  },
  {
    icon: "MessagesSquare",
    title: "Birebir İletişim",
    desc: "Ajans karmaşası yok; doğrudan uzmanınızla hızlı ve net iletişim kurarsınız.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Instagram hesabımız üç ayda organik olarak büyüdü, reklam dönüşümlerimiz neredeyse iki katına çıktı. Artık sosyal medyayı tamamen ECN Dijital'e emanet ettik.",
    name: "Ayşe K.",
    role: "Butik Mağaza Sahibi",
  },
  {
    quote:
      "Google Ads kampanyalarımız profesyonelce yönetiliyor ve her ay düzenli, anlaşılır raporlar alıyoruz. Reklam bütçemiz ilk kez bu kadar verimli kullanılıyor.",
    name: "Mehmet D.",
    role: "E-ticaret Yöneticisi",
  },
  {
    quote:
      "İçeriklerimiz artık markamızı çok daha iyi yansıtıyor. İletişim her zaman hızlı, öneriler her zaman net. Kesinlikle tavsiye ederim.",
    name: "Zeynep A.",
    role: "Kafe İşletmecisi",
  },
  {
    quote:
      "Yaklaşık 15 gün önce işletmem için Sosyal Medya Yönetimi ve Meta Reklamları konusunda hizmet aldık ve çalışmaktayız. Herhangi bir sorun yaşamadık. Tavsiye ederim.",
    name: "Emre Kandemir",
    role: "İşletme Sahibi",
    source: "Google",
  },
  {
    quote:
      "Firmamız için Meta Reklamları konusunda hizmet aldık, yaklaşık 1 aydır çalışmaktayız. Firmamıza reklamlardan olumlu dönüşler alıyoruz. Ne zaman bir sorumuz olsa hemen ulaşıyoruz. Daha uzun günler birlikte çalışma dileğiyle.",
    name: "Cemre Otomat",
    role: "Firma Yetkilisi",
    source: "Google",
  },
];

export const FAQ = [
  {
    q: "Çalışmaya nasıl başlıyoruz?",
    a: "Kısa bir ön görüşmeyle ihtiyaçlarınızı dinliyor, işletmenize özel ücretsiz bir ön analiz hazırlıyoruz. Ardından hedeflerinize uygun hizmet paketini birlikte belirleyip çalışmaya başlıyoruz.",
  },
  {
    q: "Ücretlendirme nasıl belirleniyor?",
    a: "Ücretlendirme; seçtiğiniz hizmetlerin kapsamına, platform sayısına ve reklam bütçenize göre belirlenir. Her işletmeye özel, şeffaf ve sürpriz maliyet içermeyen bir teklif sunulur.",
  },
  {
    q: "Sonuçları ne zaman görmeye başlarım?",
    a: "Reklam kampanyalarında ilk sonuçlar genellikle ilk 1-2 hafta içinde görülür. Organik sosyal medya büyümesi ise düzenli çalışmayla 2-3 ay içinde belirgin hale gelir.",
  },
  {
    q: "Raporlama nasıl yapılıyor?",
    a: "Her ay; erişim, etkileşim, reklam performansı ve dönüşüm verilerini içeren anlaşılır bir performans raporu paylaşıyor, sonuçları birlikte değerlendiriyoruz.",
  },
  {
    q: "Minimum çalışma süresi var mı?",
    a: "Sağlıklı sonuç ölçümü için en az 3 aylık çalışma öneriyoruz; ancak zorunlu uzun dönem sözleşme dayatmıyoruz. Memnuniyetiniz, birlikte çalışmamızın tek sebebi olsun istiyoruz.",
  },
];
